import React, { Component } from 'react';
import {Paper, Grid, Typography, Button, Card, IconButton, Tooltip} from '@material-ui/core';
import * as Gserv from '../services/GatewayService';
import {Settings, PrintTwoTone, UndoTwoTone, VisibilityRounded, WarningOutlined} from '@material-ui/icons';
import DatasheetView from './DatasheetView';
// import moment from 'moment';
// import Toggle from './Toggle';
import ReactToPrint from 'react-to-print';
import DropDown from './DropDown';
import moment from 'moment';
import OHSFormLink from './OHSFormLink';
// import { activeGridFilterItemsSelector } from '@material-ui/data-grid';

export default class OHSBranchReport extends Component {

    constructor(props) {
        super(props);
        this.initial_state = {
            error: false,
            error_message: '',
            querying: true,
            active_branches_array: [],
            generating_report: false,
            report_data_received: false,
            got_branches: false,
            active_appointments: [],
            missing_appointments: [],
            selected_branch: {store_code:''},
            active_empl: ''
        }

        this.state = this.initial_state;
        this.datasheetFieldSpecs_active = [
            { field: 'branch_appointment_type', headerName: 'OHS Role', width: 200},
            { field: 'employee_number', headerName: 'Empl.#', width: 90, sortable: false},
            { field: 'name', headerName: 'Appointee', width: 160},
            { field: 'job_title', headerName: 'Job Title', width: 160, sortable: false},
            { field: 'qualification_type', headerName: 'Certificate Linked to Appointment', width: 300, sortable: false,renderCell: (parms) => (
                (parms.row.certificate_link_required===1)&&
                <div>
                    {!parms.row.qualification_id_link&&
                    <IconButton disabled={true}>
                        <WarningOutlined color='secondary'/> &nbsp;&nbsp;   <Typography><i>required...</i></Typography>
                    </IconButton>}
                    {parms.row.qualification_id_link&&
                    <span>{parms.row.qualification_type}</span>}
                </div>
            )},
            { field: 'expires', headerName: 'Cert. Expires?', width: 120, sortable: false, renderCell: (parms) => (
                (parms.row.expires)&&
                <span style={{color: -moment().diff(parms.row.expires,'days') < 1 ? '#FF0000' : -moment().diff(parms.row.expires,'days') <= 30 ? '#FF9900' : '#32809a'}}>{parms.row.expires}</span>
            )},
            { field: 'q_file_attachment', headerName: 'Certificate', width: 70, align:'center', sortable:false,
            renderCell: (parms) => (
                (parms.row.q_file_attachment==="YES")&&
                <IconButton
                    onClick={()=>this.viewDoc(parms.row,'cert')} 
                >
                    <Tooltip title="View OHS Certificate">
                        <VisibilityRounded/>
                    </Tooltip>
                </IconButton>
            )},
            { field: 'appointment_date', headerName: 'Appointed?', width: 110, sortable: false},
            { field: 'file_attachment', headerName: 'Appointment Letter', width: 70, align:'center', sortable:false,
            renderCell: (parms) => (
                (parms.row.file_attachment===1)&&
                <IconButton
                    onClick={()=>this.viewDoc(parms.row,'apptmt')} 
                >
                    <Tooltip title="View Appointment Letter">
                        <VisibilityRounded />
                    </Tooltip>
                </IconButton>
            )}
        ]

        this.datasheetFieldSpecs_missing = [
            { field: 'branch_appointment_type', headerName: 'OHS Role', width: 400, sortable: false},
            { field: 'certificate_link_required', align: 'center', headerName: 'Certificate Required?', width: 180, sortable:false},
            { field: 'form_prescribed', headerName: 'Appointment Letter and Form Link', width: 300, sortable:false, renderCell: (parms) => (
                <OHSFormLink
                    form={parms.row.form_prescribed}
                    title={'Appointment Letter and Form Pack (' + parms.row.form_prescribed + ')'}
                />
            )}
        ]
    }

    componentDidMount = () => {

        // async query open cycles...
        if (!this.state.got_branches) {
            Gserv.sendCommand('query_active_branches_for_status_report',this.props.gwt)
            .then(reply=>{
                // console.log('query_active_branches reply :>> ', reply);
                if (reply.error){
                    console.log('error on return from Gserv (query_active_branches_for_status_report) :>> ', reply);
                    this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
                } else if (reply.Result!=="Success"&&reply.statusCode!==204){
                    console.log('error on return from Gserv (query_active_branches_for_status_report) :>> ', reply);
                    this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
                } else {
                    let branches_array = [];
                    if (reply.Records){
                        reply.Records.forEach(cycle => {
                            branches_array.push({store_code: cycle.store_code, branch: cycle.branch, active_employees: cycle.active_employees})
                        });
                    }
                    this.setState({active_branches_array:branches_array,got_branches:true});
                }
            });
        }

    };
    
    resetMe = () => {
        this.setState({
            error: false,
            error_message: '',
            generating_report: false,
            report_data_received: false,
            active_appointments: [],
            missing_appointments: [],
            selected_branch: {store_code:''},
            active_empl: ''
        });        
    }

    returnToSearch = () => {
        this.setState({
            error: false,
            error_message: '',
            generating_report: false,
            report_data_received: false,
            active_appointments: [],
            missing_appointments: [],
        })
    }

    handleFieldUpdate = (e) => {
        if (e.value){
            //Resolve branch obj
            const my_branch = this.state.active_branches_array.find((branch) => branch.store_code === e.value);
            this.setState({selected_branch: my_branch});

        } else {
            this.setState({selected_branch: {store_code:''}})
        }
    }

    fetchOHSData = () => {

        if (this.state.selected_branch.store_code==='') {return}

        this.setState({generating_report:true});

        //fetch ohs data...
        Gserv.sendCommand('query_ohs_appointments_for_branch_report',this.props.gwt,{selected_branch : this.state.selected_branch.store_code})
        .then(ohs_data => {
            // console.log('query_ohs_appointments_for_branch reply :>> ', ohs_data);
            if (ohs_data.error){
                console.log('error on return from Gserv (query_ohs_appointments_for_branch_report) :>> ', ohs_data);
                this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
            } else if (ohs_data.Result!=="Success"&&ohs_data.statusCode!==204){
                console.log('error on return from Gserv (query_ohs_appointments_for_branch_report) :>> ', ohs_data);
                this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
            } else {

                //format required apptmts...
                ohs_data.required_appointments.forEach(role => {
                    if (role.certificate_link_required) {
                        role.certificate_link_required = "YES";
                    } else {
                        role.certificate_link_required = "NO";
                    }
                });

                this.setState({generating_report:false, active_appointments: ohs_data.active_appointments, missing_appointments: ohs_data.required_appointments, report_data_received: true});

            }
        }); 

    }

    viewDoc = (record,doc_type) => {
        console.log('record :>> ', record);
        // console.log('doc_type :>> ', doc_type);

        Gserv.sendCommand('query_qualification_attachment',this.props.gwt,{
            file_key: doc_type==='apptmt' ? record.file_key : record.q_file_key,
            doc_type: doc_type,
            store_code: this.state.selected_branch.store_code
        })
        .then(file_url => {
            // console.log('file_url obj returned :>> ', file_url);
            if (file_url.error){
                console.log('error on return from Gserv (query_qualification_attachment) :>> ', file_url);
                this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
            } else if (file_url.Result!=="Success"&&file_url.statusCode!==204){
                console.log('error on return from Gserv (query_qualification_attachment) :>> ', file_url);
                this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
            } else {
                window.open(file_url.Url, '_blank', 'noopener,noreferrer');
            }
        }); 
    }

    render() {return(
        <Grid
            container
            direction='column'
            // justifyContent='flex-start'
            // alignContent='flex-start'
            // style={{backgroundColor:'yellow'}}
        >

            <Grid item>

                {!this.state.generating_report&&!this.state.report_data_received&&
                <Paper
                    elevation={3}
                    style={{
                        // backgroundColor:'yellow',
                        width:1025
                    }}
                >

                    <Typography color='primary' style={{paddingTop:'15px'}}>
                        Branch OHS Status Report
                    </Typography>

                    <Card
                        elevation={2}
                        style={{marginTop:'0px'}}
                    >

                        <Grid 
                            container 
                            direction='row'
                            justifyContent='center'
                            alignItems='center'
                            style={{padding:'10px', paddingLeft:'50px',marginBottom:15}}
                        >

                            {!this.state.got_branches&&!this.state.error&&
                            <div style={{color:'lightgray',marginTop:15}}>
                                <Settings className='icn-spinner' /> <small><i>loading...</i></small>
                            </div>}

                            {this.state.got_branches&&
                            <DropDown 
                                fieldMap={{
                                    field: "selected_branch",
                                    headerName: "Select Branch?",f_inputType:'dropdown',
                                    f_show:true,
                                    f_required:true
                                }}
                                setField={this.handleFieldUpdate}
                                // editRecord={this.state.filters}
                                listArray={this.state.active_branches_array}
                                disabled={this.state.generating_report}
                            />}

                        </Grid>
            
                    </Card>

                    <Button
                        variant='contained'
                        color='primary'
                        type='submit'
                        style={{marginLeft:'10px',marginTop:'15px',marginBottom:'15px'}}
                        // disabled={(!this.state.got_branches||this.state.selected_branch===''||this.state.generating_report)}
                        disabled={this.state.selected_branch.store_code===''}
                        onClick={this.fetchOHSData}
                    >
                        Generate Report
                    </Button>

                </Paper>}

                {this.state.generating_report&&!this.state.error&&
                <div>
                    <Settings className='icn-spinner' /> Generating OHS Report for Branch: <b>{this.state.selected_branch.branch}</b> 
                </div>}

                {this.state.report_data_received&&!this.state.error&&
                <Paper
                    elevation={3}
                    style={{
                        // backgroundColor:'yellow',
                        width:1025
                    }}
                >
                    <Paper
                        elevation={3}
                        style={{
                            width:'100%',
                            paddingTop: 15,
                            paddingBottom: 15,
                            marginBottom: 2
                        }}
                    >
                        <Tooltip title="Back"><IconButton aria-label='Back' onClick={this.returnToSearch}><UndoTwoTone /></IconButton></Tooltip>

                        <Tooltip title="Print or save as .pdf">
                            <span>
                            <ReactToPrint
                                content={() => this.componentRef}
                                bodyClass={'printSpecs'}
                                trigger={() => <IconButton aria-label='Print or save as .pdf'><PrintTwoTone /></IconButton>}
                            />
                            </span>
                        </Tooltip>

                    </Paper>

                    <div id='Print Delimiter' 
                        ref={(response) => (this.componentRef = response)}
                    >        
                        <style type="text/css" media="print">
                            {"@page { size: landscape; }"}
                        </style>
                        <Card
                            elevation={2}
                            style={{padding:'10px'}}
                        >
                            <Typography style={{paddingTop:'10px'}}>
                                OHS Appointment Status for branch: <b>{this.state.selected_branch.store_code}</b> ({this.state.selected_branch.active_employees} active employees)
                            </Typography>
                        </Card>

                        {this.state.active_appointments.length>0&&
                        <div>
                            <Typography style={{backgroundColor:'lightgray',padding:'10px'}} color='primary'>OHS Appointments for this Branch</Typography>

                            {/* active apptms datagrid */}
                            <DatasheetView 
                                dataset={this.state.active_appointments}
                                fieldspecs={this.datasheetFieldSpecs_active}
                                delete={false}
                                edit={false}
                                handleDelete={null}
                                handleEdit={null}
                                // loading={this.state.querying}
                                deleteHeaderName={''}
                                // pagesize={10}
                                // height={500}
                            />
                        </div>}

                        {this.state.active_appointments.length===0&&
                        <div>
                            <Typography color='secondary' style={{padding:10}}>
                                <i>No OHS appointments have been made for this branch yet.</i>    
                            </Typography>
                            <hr/>
                        </div>}

                        {this.state.missing_appointments.length>0&&
                        <div>
                            <Typography color='secondary' style={{backgroundColor:'lightred',padding:'10px', marginTop:10}}>Vacant OHS Roles</Typography>

                            {/* missing apptms datagrid */}
                            <DatasheetView 
                                dataset={this.state.missing_appointments}
                                fieldspecs={this.datasheetFieldSpecs_missing}
                                delete={false}
                                edit={false}
                                handleDelete={null}
                                handleEdit={null}
                                // loading={this.state.querying}
                                deleteHeaderName={''}
                                // pagesize={10}
                                // height={500}
                            />
                        </div>}
                        {this.state.missing_appointments.length===0&&
                        <Typography color='primary' style={{padding:10}}>
                            <i>Appointments have been made for all required OHS roles at this branch.</i>    
                        </Typography>}

                    </div>

                </Paper>}

            </Grid>

            <Grid item>
                <Typography color='secondary' style={{Width:1200,maxWidth:1200, textAlign:'center',marginBottom:'15px'}}>{this.state.error_message}</Typography>
                {this.state.error&&<Button color='primary' variant='outlined' onClick={this.resetMe}>Reset</Button>}
            </Grid>

        </Grid>
    );}
    
}